(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ink-compatibility-check"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.getElementById('compatibility-check');
    if (!section) return;

    var params = new URLSearchParams(window.location.search);
    var inkId = params.get('ink_id');
    var idField = section.querySelector('[data-ink-match-id]');
    var machineField = section.querySelector('[data-ink-match-machine]');

    if (inkId && idField && !idField.value) {
      idField.value = inkId;
    }

    if (window.location.hash === '#compatibility-check' && inkId && machineField) {
      window.setTimeout(function () {
        machineField.focus({ preventScroll: true });
      }, 120);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ink-first-hero"] && !Shopify.designMode) return;
  try {
    
  function initializeInkFinder(root) {
    if (!root || root.dataset.inkFinderReady === 'true') return;

    var form = root.querySelector('[data-ink-finder-form]');
    var input = root.querySelector('[data-ink-finder-input]');
    var resultsPanel = root.querySelector('[data-ink-finder-results]');
    var resultsList = root.querySelector('[data-ink-finder-list]');
    var status = root.querySelector('[data-ink-finder-status]');
    var verifyLink = root.querySelector('[data-ink-finder-verify]');
    var predictiveHost = root.querySelector('[data-rd-predictive-search]');
    var predictivePanel = root.querySelector('[data-rd-predictive-results]');
    var dataNode = root.querySelector('[data-ink-finder-data]');
    var copyNode = root.querySelector('[data-ink-finder-copy]');

    if (!form || !input || !resultsPanel || !resultsList || !status || !dataNode || !copyNode) return;

    var products;
    var copy;
    var lastMatches = [];

    try {
      products = JSON.parse(dataNode.textContent);
      copy = JSON.parse(copyNode.textContent);
    } catch (error) {
      return;
    }

    function normalize(value) {
      return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    }

    function extractCode(title) {
      var value = String(title || '');
      var siMatch = value.match(/\bSI\s*-\s*[A-Z0-9]+(?:\s*-\s*[A-Z0-9]+)+\b/i);
      var cijMatch = value.match(/\bCIJ\s*-?\s*\d+(?:\s*-\s*[A-Z0-9]+)+\b/i);
      var numericMatch = value.match(/\b\d{6,}\b/);
      var match = siMatch || cijMatch || numericMatch;
      return match ? match[0].replace(/\s+/g, '').toUpperCase() : '';
    }

    var duplicateCounts = {};
    var skuProductCounts = {};

    products.forEach(function (product) {
      product.code = extractCode(product.title);
      product.normalizedCode = normalize(product.code);
      product.normalizedTitle = normalize(product.title);
      product.normalizedVariants = (product.variants || [])
        .map(function (variant) {
          return {
            id: variant.id,
            title: variant.title || '',
            display: variant.sku || '',
            normalized: normalize(variant.sku),
            price: variant.price || product.price,
            available: variant.available,
            url: variant.url || product.url
          };
        });
      product.skus = product.normalizedVariants.filter(function (variant) {
        return variant.normalized;
      });
      product.optionSummary = product.normalizedVariants
        .map(function (variant) {
          return variant.title;
        })
        .filter(function (title, index, titles) {
          return title && title !== 'Default Title' && titles.indexOf(title) === index;
        })
        .join(' • ');

      if (product.normalizedCode) {
        duplicateCounts[product.normalizedCode] = (duplicateCounts[product.normalizedCode] || 0) + 1;
      }

      var productSkuCodes = {};
      product.skus.forEach(function (variant) {
        productSkuCodes[variant.normalized] = true;
      });
      Object.keys(productSkuCodes).forEach(function (skuCode) {
        skuProductCounts[skuCode] = (skuProductCounts[skuCode] || 0) + 1;
      });
    });

    function scoreProduct(product, query) {
      var exactSku = product.skus.some(function (sku) {
        return sku.normalized === query;
      });
      var startsSku = product.skus.some(function (sku) {
        return sku.normalized.indexOf(query) === 0;
      });

      if (product.normalizedCode === query) return 1000;
      if (exactSku) return 900;
      if (product.normalizedCode.indexOf(query) === 0) return 750;
      if (startsSku) return 700;
      if (product.normalizedCode.indexOf(query) > -1) return 600;
      if (product.normalizedTitle.indexOf(query) > -1) return 500;
      return 0;
    }

    function getMatches(query) {
      return products
        .map(function (product) {
          return {
            product: product,
            score: scoreProduct(product, query)
          };
        })
        .filter(function (match) {
          return match.score > 0;
        })
        .sort(function (a, b) {
          if (b.score !== a.score) return b.score - a.score;
          if (a.product.available !== b.product.available) return a.product.available ? -1 : 1;
          return a.product.title.localeCompare(b.product.title);
        })
        .slice(0, 5);
    }

    function getExactMatches(matches, query) {
      return matches.filter(function (match) {
        return match.product.normalizedCode === query || Boolean(findExactVariant(match.product, query));
      });
    }

    function findExactVariant(product, query) {
      return product.skus.find(function (variant) {
        return variant.normalized === query;
      });
    }

    function getResultUrl(product, query) {
      var exactVariant = findExactVariant(product, query);
      return exactVariant ? exactVariant.url : product.url;
    }

    function createResult(product, query) {
      var link = document.createElement('a');
      var imageWrap = document.createElement('span');
      var copyWrap = document.createElement('span');
      var code = document.createElement('span');
      var title = document.createElement('span');
      var detail = document.createElement('span');
      var meta = document.createElement('span');
      var badge = document.createElement('span');
      var price = document.createElement('span');
      var exactVariant = findExactVariant(product, query);
      var exactCode = product.normalizedCode === query;
      var exactSku = Boolean(exactVariant);
      var duplicate = duplicateCounts[query] > 1 || skuProductCounts[query] > 1;

      link.className = 'ink-finder__result';
      link.href = getResultUrl(product, query);
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', 'false');
      link.setAttribute('data-ink-finder-option', '');

      imageWrap.className = 'ink-finder__result-image';
      if (product.image) {
        var image = document.createElement('img');
        image.src = product.image;
        image.alt = '';
        image.loading = 'lazy';
        imageWrap.appendChild(image);
      } else {
        var imageFallback = document.createElement('span');
        imageFallback.textContent = 'INK';
        imageWrap.appendChild(imageFallback);
      }

      copyWrap.className = 'ink-finder__result-copy';
      code.className = 'ink-finder__result-code';
      code.textContent = exactVariant
        ? exactVariant.display
        : product.code || (product.skus[0] && product.skus[0].display) || product.title;
      title.className = 'ink-finder__result-title';
      title.textContent = product.title;
      copyWrap.appendChild(code);
      copyWrap.appendChild(title);
      if ((exactVariant && exactVariant.title && exactVariant.title !== 'Default Title') || product.optionSummary) {
        detail.className = 'ink-finder__result-detail';
        detail.textContent = exactVariant && exactVariant.title !== 'Default Title'
          ? 'Pack: ' + exactVariant.title
          : 'Options: ' + product.optionSummary;
        copyWrap.appendChild(detail);
      }

      meta.className = 'ink-finder__result-meta';
      badge.className = 'ink-finder__result-badge';

      if (duplicate && exactCode) {
        badge.textContent = copy.multipleBadge;
        badge.classList.add('ink-finder__result-badge--warn');
      } else if (exactCode) {
        badge.textContent = copy.codeMatch;
      } else if (exactSku) {
        badge.textContent = copy.skuMatch;
        badge.classList.add('ink-finder__result-badge--warn');
      } else {
        badge.textContent = copy.possible;
        badge.classList.add('ink-finder__result-badge--warn');
      }

      price.className = 'ink-finder__result-price';
      price.textContent = exactVariant
        ? (exactVariant.available ? exactVariant.price : copy.soldOut)
        : (product.available ? product.price : copy.soldOut);
      meta.appendChild(badge);
      meta.appendChild(price);

      link.appendChild(imageWrap);
      link.appendChild(copyWrap);
      link.appendChild(meta);
      return link;
    }

    function setResultsVisibility(visible) {
      resultsPanel.hidden = !visible;
      var predictiveVisible = predictivePanel && !predictivePanel.hidden;
      input.setAttribute('aria-expanded', visible || predictiveVisible ? 'true' : 'false');
    }

    function renderResults() {
      var query = normalize(input.value);
      resultsList.replaceChildren();

      if (query.length < 3) {
        lastMatches = [];
        setResultsVisibility(false);
        status.textContent = copy.empty;
        return lastMatches;
      }

      var matches = getMatches(query);
      lastMatches = matches;
      setResultsVisibility(true);

      if (!matches.length) {
        status.textContent = copy.none;
        return matches;
      }

      var exactMatches = getExactMatches(matches, query);
      var hasDuplicate = exactMatches.some(function (match) {
        return duplicateCounts[query] > 1 || skuProductCounts[query] > 1;
      });

      if (hasDuplicate || exactMatches.length > 1) {
        status.textContent = copy.multiple;
      } else if (exactMatches.length === 1) {
        status.textContent = copy.exact;
      } else {
        status.textContent = copy.partial;
      }

      matches.forEach(function (match) {
        resultsList.appendChild(createResult(match.product, query));
      });

      return matches;
    }

    function suspendPredictiveSearch() {
      if (!predictiveHost) return;

      predictiveHost.dataset.rdPredictiveSuspended = 'true';
      predictiveHost.dispatchEvent(new CustomEvent('redesign:predictive-search:suspend'));

      if (predictivePanel) predictivePanel.hidden = true;
    }

    function resumePredictiveSearch() {
      if (!predictiveHost) return;

      predictiveHost.dataset.rdPredictiveSuspended = 'false';
      predictiveHost.dispatchEvent(new CustomEvent('redesign:predictive-search:resume'));
    }

    function transferToCompatibility() {
      var idField = document.querySelector('[data-ink-match-id]');
      var candidateField = document.querySelector('[data-ink-match-candidates]');
      var machineField = document.querySelector('[data-ink-match-machine]');

      if (idField && input.value.trim()) {
        idField.value = input.value.trim().toUpperCase();
      }

      if (candidateField) {
        var query = normalize(input.value);
        candidateField.value = lastMatches.map(function (match) {
          return match.product.title + ' — ' + getResultUrl(match.product, query);
        }).join('\n');
      }

      if (machineField) {
        window.setTimeout(function () {
          machineField.focus({ preventScroll: true });
        }, 80);
      }
    }

    input.addEventListener('input', function () {
      var query = normalize(input.value);
      var matches = query.length >= 3 ? getMatches(query) : [];
      var exactMatches = getExactMatches(matches, query);

      if (exactMatches.length > 0) {
        suspendPredictiveSearch();
        renderResults();
        return;
      }

      resumePredictiveSearch();
      setResultsVisibility(false);
      resultsList.replaceChildren();
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setResultsVisibility(false);
        input.setAttribute('aria-expanded', 'false');
        return;
      }

      if (event.key === 'ArrowDown' && !resultsPanel.hidden) {
        var firstOption = resultsList.querySelector('[data-ink-finder-option]');
        if (firstOption) {
          event.preventDefault();
          firstOption.focus();
        }
      }
    });

    form.addEventListener('submit', function (event) {
      var query = normalize(input.value);
      if (query.length < 3) return;

      var matches = getMatches(query);
      var exactMatches = getExactMatches(matches, query);
      if (exactMatches.length === 0) return;

      event.preventDefault();
      suspendPredictiveSearch();
      renderResults();
      var unambiguous = exactMatches.length === 1 &&
        (duplicateCounts[query] || 0) <= 1 &&
        (skuProductCounts[query] || 0) <= 1;

      if (unambiguous) {
        window.location.assign(getResultUrl(exactMatches[0].product, query));
        return;
      }

      status.focus();
    });

    resultsPanel.addEventListener('keydown', function (event) {
      var options = Array.prototype.slice.call(resultsList.querySelectorAll('[data-ink-finder-option]'));
      var currentIndex = options.indexOf(document.activeElement);

      if (event.key === 'Escape') {
        event.preventDefault();
        setResultsVisibility(false);
        input.focus();
        return;
      }

      if (event.key === 'ArrowDown' && currentIndex > -1) {
        event.preventDefault();
        options[(currentIndex + 1) % options.length].focus();
      }

      if (event.key === 'ArrowUp' && currentIndex > -1) {
        event.preventDefault();
        if (currentIndex === 0) {
          input.focus();
        } else {
          options[currentIndex - 1].focus();
        }
      }
    });

    if (verifyLink) {
      verifyLink.addEventListener('click', transferToCompatibility);
    }

    if (predictiveHost) {
      if (window.initializeRedesignPredictiveSearch) {
        window.initializeRedesignPredictiveSearch(predictiveHost);
      } else {
        document.addEventListener('redesign:predictive-search:ready', function () {
          window.initializeRedesignPredictiveSearch(predictiveHost);
        }, { once: true });
      }
    }

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) {
        setResultsVisibility(false);
      }
    });

    root.dataset.inkFinderReady = 'true';
  }

  document.querySelectorAll('[data-ink-finder]').forEach(initializeInkFinder);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-ink-finder]').forEach(initializeInkFinder);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["redesign-header"]) return;
  try {
    
  (function () {
    function initializePredictiveSearch(host) {
      if (host.dataset.rdPredictiveReady === 'true') return;

      var form = host.querySelector('[data-rd-predictive-form]');
      var input = host.querySelector('[data-rd-predictive-input]');
      var results = host.querySelector('[data-rd-predictive-results]');
      var heading = host.querySelector('[data-rd-predictive-heading]');
      var status = host.querySelector('[data-rd-predictive-status]');
      var list = host.querySelector('[data-rd-predictive-list]');
      var empty = host.querySelector('[data-rd-predictive-empty]');
      var viewAll = host.querySelector('[data-rd-predictive-all]');
      var queryLabel = host.querySelector('[data-rd-predictive-query]');
      var requestController;
      var debounceTimer;

      if (!form || !input || !results || !list) return;

      function setExpanded(expanded) {
        results.hidden = !expanded;
        var alternateResults = host.querySelector('[data-rd-predictive-alternate]:not([hidden])');
        input.setAttribute('aria-expanded', expanded || alternateResults ? 'true' : 'false');
      }

      function clearResults() {
        list.innerHTML = '';
        heading.hidden = true;
        status.hidden = true;
        empty.hidden = true;
        viewAll.hidden = true;
        setExpanded(false);
      }

      function showLoading() {
        list.innerHTML = '';
        heading.hidden = true;
        empty.hidden = true;
        viewAll.hidden = true;
        status.textContent = host.dataset.searching || 'Searching products…';
        status.hidden = false;
        setExpanded(true);
      }

      function updateViewAll(term) {
        var fullResultsUrl = new URL(form.action, window.location.origin);
        fullResultsUrl.searchParams.set('type', 'product');
        fullResultsUrl.searchParams.set('options[prefix]', 'last');
        fullResultsUrl.searchParams.set('q', term);
        viewAll.href = fullResultsUrl.pathname + fullResultsUrl.search;
        queryLabel.textContent = term;
      }

      function showResponse(term, responseText) {
        if (input.value.trim() !== term || host.dataset.rdPredictiveSuspended === 'true') return;

        var responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
        var payload = responseDocument.querySelector('[data-rd-predictive-payload]');
        var countNode = responseDocument.querySelector('[data-rd-predictive-count]');
        var resultCount = countNode ? parseInt(countNode.dataset.rdPredictiveCount, 10) : 0;

        status.hidden = true;
        list.innerHTML = payload ? payload.innerHTML : '';
        heading.hidden = resultCount === 0;
        empty.hidden = resultCount > 0;
        viewAll.hidden = false;
        updateViewAll(term);
        setExpanded(true);
      }

      function getResults(term) {
        if (host.dataset.rdPredictiveSuspended === 'true') {
          clearResults();
          return;
        }

        requestController = new AbortController();

        var predictiveUrl = new URL(host.dataset.predictiveUrl, window.location.origin);
        predictiveUrl.searchParams.set('q', term);
        predictiveUrl.searchParams.set('resources[type]', 'product');
        predictiveUrl.searchParams.set('resources[limit]', '5');
        predictiveUrl.searchParams.set('resources[options][fields]', 'title,product_type,variants.sku,variants.title,vendor');
        predictiveUrl.searchParams.set('resources[options][prefix]', 'last');
        predictiveUrl.searchParams.set('resources[options][unavailable_products]', 'last');
        predictiveUrl.searchParams.set('section_id', 'redesign-predictive-search');

        fetch(predictiveUrl.toString(), {
          signal: requestController.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Predictive search request failed');
            return response.text();
          })
          .then(function (responseText) {
            showResponse(term, responseText);
          })
          .catch(function (error) {
            if (error.name === 'AbortError') return;
            if (input.value.trim() !== term || host.dataset.rdPredictiveSuspended === 'true') return;
            status.hidden = true;
            heading.hidden = true;
            list.innerHTML = '';
            empty.hidden = false;
            viewAll.hidden = false;
            updateViewAll(term);
            setExpanded(true);
          });
      }

      function queueSearch(term) {
        window.clearTimeout(debounceTimer);

        if (requestController) requestController.abort();

        if (term.length < 2) {
          clearResults();
          return;
        }

        if (host.dataset.rdPredictiveSuspended === 'true') {
          clearResults();
          return;
        }

        showLoading();
        debounceTimer = window.setTimeout(function () {
          getResults(term);
        }, 240);
      }

      input.addEventListener('input', function () {
        queueSearch(input.value.trim());
      });

      input.addEventListener('focus', function () {
        if (host.dataset.rdPredictiveSuspended === 'true') return;
        if (input.value.trim().length < 2) return;
        if (list.children.length > 0 || !empty.hidden) setExpanded(true);
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          setExpanded(false);
          return;
        }

        if (event.key !== 'ArrowDown' || results.hidden) return;

        var firstOption = list.querySelector('[data-rd-predictive-option]');
        if (firstOption) {
          event.preventDefault();
          firstOption.focus();
        }
      });

      results.addEventListener('keydown', function (event) {
        var options = Array.prototype.slice.call(list.querySelectorAll('[data-rd-predictive-option]'));
        var currentIndex = options.indexOf(document.activeElement);

        if (event.key === 'Escape') {
          event.preventDefault();
          setExpanded(false);
          input.focus();
          return;
        }

        if (event.key === 'ArrowDown' && currentIndex > -1) {
          event.preventDefault();
          options[(currentIndex + 1) % options.length].focus();
        }

        if (event.key === 'ArrowUp' && currentIndex > -1) {
          event.preventDefault();
          if (currentIndex === 0) {
            input.focus();
          } else {
            options[currentIndex - 1].focus();
          }
        }
      });

      document.addEventListener('click', function (event) {
        if (!host.contains(event.target)) setExpanded(false);
      });

      host.addEventListener('redesign:predictive-search:suspend', function () {
        host.dataset.rdPredictiveSuspended = 'true';
        window.clearTimeout(debounceTimer);
        if (requestController) requestController.abort();
        clearResults();
      });

      host.addEventListener('redesign:predictive-search:resume', function () {
        host.dataset.rdPredictiveSuspended = 'false';
        queueSearch(input.value.trim());
      });

      form.addEventListener('submit', function (event) {
        window.clearTimeout(debounceTimer);
        if (requestController) requestController.abort();

        if (!input.value.trim()) {
          event.preventDefault();

          list.innerHTML = '';
          heading.hidden = true;
          empty.hidden = true;
          viewAll.hidden = true;
          status.textContent = host.dataset.emptyPrompt || 'Enter a product name or ink ID.';
          status.hidden = false;
          setExpanded(true);
          input.focus();
          return;
        }

        setExpanded(false);
      });

      host.dataset.rdPredictiveReady = 'true';
    }

    window.initializeRedesignPredictiveSearch = initializePredictiveSearch;

    document.querySelectorAll('[data-rd-predictive-search]').forEach(initializePredictiveSearch);
    document.dispatchEvent(new CustomEvent('redesign:predictive-search:ready'));

    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-rd-predictive-search]').forEach(initializePredictiveSearch);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
